import { H3, Paragraph, WrapLgMarginBottom } from "App/global-style";

import styled from "styled-components";

export const FlexWrap = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
`;

export const StyledHouseH3 = styled(H3)`
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const SubHeaderWrap = styled(WrapLgMarginBottom)`
  margin-top: ${({ theme }) => theme.spacing.lg};
`;

export const AdditionalBuildingsWrap = styled.div`
  background-color: ${({ theme }) =>
    theme.table ? theme.table.backgroundColor : theme.brandColors.surface.main};
  margin: ${({ theme }) => theme.spacing.sm} 0;
  padding: ${({ theme }) => theme.spacing.sm};
`;

export const AdditionalBuildingHeader = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;

export const ParagraphAsLabel = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  line-height: ${({ theme }) => theme.lineHeight.xs};
  margin: 0;
`;

export const ParagraphAsHint = styled(Paragraph)`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  margin-top: ${({ theme }) => theme.spacing.xs};
`;
